import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import solar_roof from "../../assets/images/services/solar-roof.jpg";

const stats = [{ label: "Warranty", value: "25 Years" }];

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the image container
      sr.reveal("#solar .relative.overflow-hidden", {
        origin: "left",
        distance: "30px",
        duration: 700,
      });

      // reveal the headings and intro text
      sr.reveal("#solar .font-united_sans_sm, #solar .font-united_sans_lg", {
        origin: "top",
        distance: "20px",
        duration: 600,
        interval: 150,
        delay: 200,
      });

      // reveal the paragraphs
      sr.reveal("#solar .max-w-xl p", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 150,
        delay: 400,
      });

      // reveal the stats
      sr.reveal("#solar dl div", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 150,
        delay: 600,
      });
    }
  }, []);

  return (
    <div id="solar" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-4">
            <div className="relative overflow-hidden rounded-3xl bg-gray-900 px-6 pb-9 pt-64 shadow-2xl sm:px-12 lg:max-w-xlg lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
              <img
                alt=""
                src={solar_roof}
                className="absolute inset-0 size-full object-cover"
              />
            </div>
          </div>
          <div>
            <div className="text-base/7 text-gray-700 lg:max-w-lg">
              <p className="font-united_sans_sm text-base/7 font-semibold text-[#D2B48C]">
                SOLAR POWER
              </p>
              <h1 className="font-united_sans_lg mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                GAF Timberline Solar™
              </h1>
              <div className="max-w-xl">
                <p className="mt-6">
                  The GAF Timberline Solar™ roofing system integrates solar
                  technology directly into the roof shingles, offering a sleek,
                  low-profile alternative to traditional solar panels. As the
                  first nailable solar shingle, Timberline Solar™ is installed
                  like a conventional roof while generating clean, renewable
                  energy for your home. This innovative system combines
                  durability, efficiency, and aesthetic appeal, allowing
                  homeowners to harness solar power without compromising the
                  look of their roof.
                </p>
                <p className="mt-8">
                  One of the key advantages of Timberline Solar™ is its
                  integrated warranties, covering both the roofing system and
                  solar components for workmanship and durability. Additionally,
                  the system includes a power production guarantee, ensuring
                  that if the solar system underperforms, the homeowner will be
                  reimbursed by the manufacturer every five years throughout the
                  25-year warranty period. This guarantees peace of mind,
                  knowing your roof and solar investment are protected for
                  decades to come.
                </p>
              </div>
            </div>
            <dl className="mt-10 grid grid-cols-2 gap-8 border-t border-gray-900/10 pt-10 sm:grid-cols-3">
              {stats.map((stat, statIdx) => (
                <div key={statIdx}>
                  <dt className="text-sm/6 font-semibold text-gray-600">
                    {stat.label}
                  </dt>
                  <dd className="mt-2 text-3xl/10 font-bold tracking-tight text-gray-900">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
